export const health_medical = [
  { char: '🩺', name: 'Stethoscope', nameZh: '聽診器/健檢', keywords: ['doctor', 'check', 'vet'], hot: true },
  { char: '🏥', name: 'Hospital', nameZh: '醫療機構', keywords: ['building', 'sick', 'medical'] },
  { char: '💊', name: 'Pill', nameZh: '藥劑/保健品', keywords: ['med', 'health', 'tablet'], hot: true },
  { char: '💉', name: 'Syringe', nameZh: '疫苗/針劑', keywords: ['vaccine', 'blood', 'doctor'] },
  { char: '🩹', name: 'Bandage', nameZh: '受傷/療癒', keywords: ['hurt', 'heal', 'care'] },
  { char: '🩸', name: 'Blood', nameZh: '捐血/血液', keywords: ['red', 'power', 'life'] },
  { char: '🧬', name: 'DNA', nameZh: '基因/根本', keywords: ['science', 'bio', 'life'] },
  { char: '🩻', name: 'X-ray', nameZh: '透視/真相', keywords: ['bone', 'look', 'inside'] },
  { char: '🔬', name: 'Microscope', nameZh: '微觀研究', keywords: ['lab', 'research', 'science'] },
  { char: '🧴', name: 'Lotion', nameZh: '皮膚護理', keywords: ['cream', 'skincare', 'protect'] },
  { char: '🌡️', name: 'Thermometer', nameZh: '體溫/警報', keywords: ['hot', 'cold', 'fever'] },
  { char: '🚑', name: 'Ambulance', nameZh: '緊急救護', keywords: ['fast', 'emergency', 'help'] },
];